module.exports = __webpack_public_path__ + "media/images/workplace/activity_points/payout_providers/amazon-logo-c85adf3bd9e4e37fbaa3827deab78302.svg";